import { Download01Icon } from '@/components/icons/Download01Icon';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';

import { useDocumentDownload } from '../../files/hooks/useFileDownload';

export interface DownloadDocumentMenuItemProps {
  documentId: string;
  showDivider?: boolean;
}

export function DownloadDocumentMenuItem({
  documentId,
  showDivider = false,
}: DownloadDocumentMenuItemProps) {
  const [downloadFile, { loading }] = useDocumentDownload();

  return (
    <MenuItem
      icon={<Download01Icon size={18} />}
      loading={loading}
      muiMenuItemProps={{ divider: showDivider }}
      label="Download document"
      onClick={() => downloadFile(documentId)}
    />
  );
}
